import { ModalTitle } from '@modals/core-ui/ModalTitle';
import { ModalWrapper } from '@modals/core-ui/ModalWrapper';
import { Filter } from '@pages/User/RepositoriesListPage/Filter';
import { useModalContext } from '@providers/ModalProvider';

import { Content } from './styles/Content';
import { TProps } from './types/TProps';

export const CasesFiltersModal = ({ onCancel, createdFilter, createdFilterOnChange, onSubmit }: TProps) => {
  const { closeModal } = useModalContext();

  return (
    <ModalWrapper width="400px" onCancel={onCancel}>
      <ModalTitle>Filters</ModalTitle>
      <Content>
        <Filter
          hideHeader
          createdFilter={createdFilter}
          createdFilterOnChange={createdFilterOnChange}
          handleSubmit={onSubmit}
          handleClose={closeModal}
        />
      </Content>
    </ModalWrapper>
  );
};
